import React, { ReactNode } from 'react'

import DriftingParticles from 'assets/animations/DriftingParticles'

import Box from 'components_new/atoms/Box'
import Icon from 'components_new/atoms/Icon'
import Skeleton from 'components_new/atoms/Skeleton'
import Text from 'components_new/atoms/Text'

import ChatAvatar from 'components_new/organisms/ChatBox/ChatAvatar'

interface CompletedSectionProps {
  background?: boolean
  children?: ReactNode
  description?: string
  direction?: 'row' | 'column'
  title: string
  sx?: object
  variant?: 'default' | 'logo'
}

const CompletedSection = React.forwardRef(
  (props: CompletedSectionProps, ref: any) => {
    const { background, children, description, direction, title, sx, variant } =
      props

    const iconSize = direction === 'row' ? 24 : 40

    return (
      <Box
        ref={ref}
        sx={{
          alignItems: 'center',
          borderRadius: 1,
          display: 'flex',
          flexDirection: direction,
          gap: 2,
          height: '100%',
          justifyContent: 'center',
          p: 2,
          position: 'relative',
          ...sx
        }}
      >
        {background && 1 !== 1 ? (
          <Skeleton
            height={'100%'}
            width={'100%'}
            sx={{ left: 0, position: 'absolute', top: 0, zIndex: 0 }}
          />
        ) : null}

        {background ? (
          <DriftingParticles
            sx={{
              height: '100%',
              left: 0,
              position: 'absolute',
              top: 0,
              width: '100%',
              zIndex: 0
            }}
            variant="hover"
          />
        ) : null}

        <Box sx={{ zIndex: 1 }}>
          {variant === 'logo' ? (
            <Box
              sx={{
                height: iconSize,
                width: iconSize
              }}
            >
              <ChatAvatar active={false} />
            </Box>
          ) : (
            <Icon
              color={background ? 'brand' : undefined}
              name="Done"
              sx={{
                fontSize: iconSize
              }}
            />
          )}
        </Box>
        <Text
          align="center"
          color="text.primary"
          variant="h6"
          sx={{ zIndex: 1 }}
        >
          {title}
        </Text>
        <Text
          align="center"
          color="text.secondary"
          variant="body1"
          sx={{ zIndex: 1 }}
        >
          {description}
        </Text>
        {children ? (
          <Box sx={{ width: '100%', zIndex: 1 }}>{children}</Box>
        ) : null}
      </Box>
    )
  }
)

CompletedSection.displayName = 'CompletedSection'
export default CompletedSection
